import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=52752fd7&scoped=true&"
import script from "./SidePanel.vue?vue&type=script&lang=js&"
export * from "./SidePanel.vue?vue&type=script&lang=js&"
import style0 from "./SidePanel.vue?vue&type=style&index=0&id=52752fd7&scoped=true&lang=css&"
import style1 from "./SidePanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52752fd7",
  null
  
)

export default component.exports